import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Prompt, useHistory, useLocation } from 'react-router-dom';

import { ReduxStoreData } from '@funnels/types';

import { ConveyancingBlockerModal } from './Modal';

function mapState(currentState: ReduxStoreData) {
  const loading =
    currentState.applications.loading +
    currentState.applicants.loading +
    currentState.assets.loading +
    currentState.employments.loading +
    currentState.companies.loading +
    currentState.incomes.loading +
    currentState.conveyancing.loading +
    currentState.liabilities.loading;
  return { loading };
}

interface ConveyancingNavigationBlockerProps {
  referNotCompleted: boolean;
  onContinueToRefer?: () => void | Promise<void>;
  onCompleteLater?: () => void | Promise<void>;
}

export function ConveyancingNavigationBlocker({
  referNotCompleted,
  onContinueToRefer,
  onCompleteLater,
}: ConveyancingNavigationBlockerProps) {
  const history = useHistory();
  const { loading } = useSelector(mapState);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [nextLocation, setNextLocation] = useState<ReturnType<typeof useLocation>>();

  useEffect(() => {
    if (shouldNavigate && !!nextLocation && !loading) {
      setIsModalVisible(false);
      setShouldNavigate(false);
      history.push(nextLocation.pathname);
    }
  }, [shouldNavigate, nextLocation, history, loading]);

  return (
    <>
      <Prompt
        when={referNotCompleted}
        message={(location) => {
          if (shouldNavigate) return true;
          setIsModalVisible(true);
          setNextLocation(location);
          return false;
        }}
      />
      <ConveyancingBlockerModal
        isVisible={isModalVisible}
        onHide={() => {
          setIsModalVisible(false);
        }}
        onContinueToRefer={async () => {
          if (onContinueToRefer) {
            await Promise.resolve(onContinueToRefer());
          }
          setShouldNavigate(true);
          setIsModalVisible(false);
        }}
        onCompleteLater={async () => {
          if (onCompleteLater) {
            await Promise.resolve(onCompleteLater());
          }
          setShouldNavigate(true);
        }}
      />
    </>
  );
}
